import { createSlice } from "@reduxjs/toolkit";
//import * as api from "@/services/api";
export const Status = {
  IDLE: "Idle",
  CREATING: "Creating",
  CREATED: "Created",
  DELETING: "Deleting",
  DELETED: "Deleted",
  UPDATING: "Updateing",
  PREVIEWING: "Previewing",
  CONFIRMED: "Confirmed",
};

const initialState = {
  modalAnnouncement: undefined,
  offer: {
    correlatedServices: [],
    correlatedAnnouncements: [],
  },
};

const slice = createSlice({
  name: "detail",

  initialState,
  reducers: {
    setModalAnnouncement(state, action) {
      const { annoucement } = action.payload;
      state.modalAnnouncement = annoucement;
    },
    updateOfferWithAnnouncement(state, action) {
      const { annoucement } = action.payload;
      const { id } = annoucement;
      if (state.offer.correlatedAnnouncements.find((ann) => ann === id)) {
        // if present
        state.offer.correlatedAnnouncements =
          state.offer.correlatedAnnouncements.filter((ann) => ann !== id);
      } else {
        state.offer.correlatedAnnouncements.push(id);
      }
    },
    updateOfferWithService(state, action) {
      const { service } = action.payload;
      const { id } = service;
      if (state.offer.correlatedServices.find((serv) => serv === id)) {
        // if present
        state.offer.correlatedServices = state.offer.correlatedServices.filter(
          (serv) => serv !== id
        );
      } else {
        state.offer.correlatedServices.push(id);
      }
    },
    clearOffer(state, action) {
      state.offer = {
        correlatedServices: [],
        correlatedAnnouncements: [],
      };
    },
  },
  extraReducers: {},
});

export default slice.reducer;

export const {
  setModalAnnouncement,
  setStatus,
  updateOfferWithAnnouncement,
  updateOfferWithService,
  clearOffer,
} = slice.actions;

export const selectModalAnnouncement = (state) =>
  state.detail.modalAnnouncement;

export const selectOffer = (state) => state.detail.offer;
